export default "__VITE_ASSET__1l2P5stQ__"